<div class="content-heading">
  <div class="header-container">
    <h3>Detalle de Configuración de Vehículo</h3>
    <small>Gestión de especificaciones técnicas para transporte</small>
  </div>
</div>

<div class="container-fluid">
  <div class="card card-default">
    <div class="card-body">
      <form #Form="ngForm" (ngSubmit)="formSubmit()">
        
        <div class="row">
          <div class="col-md-4">
            <aph-custom-text 
              label="Código" 
              placeholder="Ej. T3-S2" 
              [(ngModel)]="vehicleconfig.VehicleKey" 
              name="VehicleKey" 
              [required]="true" 
              [maxLength]="10" 
              [disabled]="!isNew"
              style="border:none;">
            </aph-custom-text>
          </div>
          <div class="col-md-8">
            <aph-custom-text 
              label="Descripción" 
              placeholder="Descripción completa del vehículo" 
              [(ngModel)]="vehicleconfig.VehicleDescription" 
              name="VehicleDescription" 
              [required]="true" 
              [maxLength]="300"
              style="border:none;">
            </aph-custom-text>
          </div>
        </div>

        <h5 class="mt-4 text-muted">Especificaciones de Peso</h5>
        <hr>

        <div class="row">
          <div class="col-lg-3 col-md-6 mt-2">
            <aph-custom-text 
              label="Peso Bruto ET y A" 
              [(ngModel)]="vehicleconfig.VehicleWeightETA" 
              name="VehicleWeightETA" 
              [required]="true" 
              type="numeric"
              [allowDecimal]="true"
              [allowNegative]="false"
              [maxLength]="15"
              style="border:none;">
            </aph-custom-text>
          </div>
          <div class="col-lg-3 col-md-6 mt-2">
            <aph-custom-text 
              label="Peso Bruto B" 
              [(ngModel)]="vehicleconfig.VehicleWeightB" 
              name="VehicleWeightB" 
              [required]="true" 
              type="numeric"
              [allowDecimal]="true"
              [allowNegative]="false"
              [maxLength]="15"
              style="border:none;">
            </aph-custom-text>
          </div>
          <div class="col-lg-3 col-md-6 mt-2">
            <aph-custom-text 
              label="Peso Bruto C" 
              [(ngModel)]="vehicleconfig.VehicleWeightC" 
              name="VehicleWeightC" 
              [required]="true" 
              type="numeric"
              [allowDecimal]="true"
              [allowNegative]="false"
              [maxLength]="15"
              style="border:none;">
            </aph-custom-text>
          </div>
          <div class="col-lg-3 col-md-6 mt-2">
            <aph-custom-text 
              label="Peso Bruto D" 
              [(ngModel)]="vehicleconfig.VehicleWeightD" 
              name="VehicleWeightD" 
              [required]="true" 
              type="numeric"
              [allowDecimal]="true"
              [allowNegative]="false"
              [maxLength]="15"
              style="border:none;">
            </aph-custom-text>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-md-4">
            <aph-custom-text 
              label="Largo Total (m)" 
              placeholder="Ej. 18.50" 
              [(ngModel)]="vehicleconfig.VehicleTotalDimensions" 
              name="VehicleTotalDimensions" 
              [required]="true" 
              type="numeric"
              [allowDecimal]="true"
              [allowNegative]="false"
              [maxLength]="15"
              style="border:none;">
            </aph-custom-text>
          </div>
        </div>

        <hr class="mt-4">

        <div class="row mt-3">
          <div class="col-12 d-flex">
            <aph-custom-buttons 
              preset="save" 
              label="Guardar" 
              type="submit" 
              [disabled]="!Form.valid"
              class="mr-2">
            </aph-custom-buttons>

            <aph-custom-buttons 
              preset="exit" 
              label="Volver" 
              (btnClick)="btnCancelOnClick()">
            </aph-custom-buttons>
          </div>
        </div>

      </form>
    </div>
  </div>
</div>